import { type ThemeConfig, theme as antdTheme } from 'antd'

export const darkTheme: ThemeConfig = {
  hashed: false,
  cssVar: {
    prefix: '',
    key: 'app',
  },
  algorithm: antdTheme.darkAlgorithm,
  token: {
    colorPrimary: '#F46036',
    colorLink: '#F46036',
    colorInfo: '#488BE8',
    colorSuccess: '#79C886',
    colorWarning: '#FAAD14',
    colorError: '#F14D5B',
    fontFamily: 'Roboto, sans-serif',
    colorBgBase: '#000000',
    gray7: '#BFBFBF', // Fallback for the new brand tokens - used in the skeleton image icon
    tekhelet6: '#432F91',
    tekhelet5: '#5039B0',
    tekhelet4: '#5C45C2',
    tekhelet3: '#6F5AC9',
    tekhelet2: '#4C36A8',
    tekhelet1: '#47329B',
    tekhelet0: '#412E8C',
    royalPurple9: '#CCB8E6',
    royalPurple7: '#9374C3',
    royalPurple6: '#8150BF',
    royalPurple5: '#703FAD',
    royalPurple4: '#5F3594',
    royalPurple1: '#361F54',
    royalPurple0: '#321E49',
  },
  components: {
    Layout: {
      headerBg: '#000000',
    },
    Menu: {
      itemBg: '#000000',
    },
  },
}
